import getClosestHTMLElement from './getClosestHTMLElement';

// Helper that determines where a touch event occurred relative to an element's box model:
// Returns:
//   - 'content'
//   - 'padding'
//   - 'outside'
//   - undefined (if no valid target element was found)
export const getTouchLocation = (event: TouchEvent) => {
  if (!event.target) {
    return undefined;
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- event.target is EventTarget | null; we checked !event.target above, and DOM touch targets are always Node instances
  const target = getClosestHTMLElement(event.target as Node);

  if (!target) {
    return undefined;
  }

  const rect = target.getBoundingClientRect();
  const computedStyle = getComputedStyle(target);

  // Get all padding values from CSS
  const paddingLeft = parseFloat(computedStyle.paddingLeft);
  const paddingTop = parseFloat(computedStyle.paddingTop);
  const paddingRight = parseFloat(computedStyle.paddingRight);
  const paddingBottom = parseFloat(computedStyle.paddingBottom);

  // Calculate content area boundaries (excluding padding)
  const contentLeft = rect.left + paddingLeft;
  const contentTop = rect.top + paddingTop;
  const contentRight = rect.right - paddingRight;
  const contentBottom = rect.bottom - paddingBottom;

  const touch = event.touches[0];

  if (!touch) {
    return undefined;
  }

  const touchX = touch.clientX;
  const touchY = touch.clientY;

  // Check if touch is within the element bounds
  const isInElement = touchX >= rect.left && touchX <= rect.right &&
                     touchY >= rect.top && touchY <= rect.bottom;

  if (!isInElement) {
    return 'outside';
  }

  // Check if touch is in content area
  const isInContent = touchX >= contentLeft && touchX <= contentRight &&
                     touchY >= contentTop && touchY <= contentBottom;

  if (isInContent) {
    return 'content';
  } else {
    return 'padding';
  }
};
